'use client';
import { useSyncExternalStore } from 'react';
function subscribe(callback) {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
        return () => { };
    }
    const mql = window.matchMedia('(prefers-reduced-motion: reduce)');
    mql.addEventListener('change', callback);
    return () => mql.removeEventListener('change', callback);
}
function getSnapshot() {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function')
        return false;
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}
function getServerSnapshot() {
    return false;
}
/** Live `prefers-reduced-motion` value — used where CSS alone can't swap
 * animated content for a static frame (e.g. picking a still mascot pose,
 * skipping a JS-driven celebration burst). */
export function usePrefersReducedMotion() {
    return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
